import { primitiveColors } from 'fitify-ui/src/theme/generated/primitive-colors'
import { zIndexes } from 'fitify-ui-onboarding/src/theme/zIndexes'
import { styled } from 'styled-components'

export const TRANSITION_LENGTH_MS = 200

export const StyledContainer = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  z-index: ${zIndexes.pageLoader};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${primitiveColors['New Primitives Web']['General/White']};
  color: ${primitiveColors['New Primitives Web']['General/Black']};
  inset: 0;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: opacity ${TRANSITION_LENGTH_MS}ms;
`

export const LOADER_SIZE = 48
export const LOADER_STROKE_WIDTH = 8

const RADIUS = (LOADER_SIZE - LOADER_STROKE_WIDTH) / 2
const CIRCUMFERENCE = 2 * Math.PI * RADIUS
const MIN_ARC_LENGTH = LOADER_STROKE_WIDTH

export const StyledSvg = styled.svg`
  width: ${LOADER_SIZE / 16}rem;
  height: ${LOADER_SIZE / 16}rem;
  animation: loader-rotate 2s infinite linear;

  @keyframes loader-rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`

export const StyledArc = styled.circle`
  animation: loader-dash 1.5s infinite ease-in-out;
  fill: none;
  stroke: ${primitiveColors['New Primitives Web']['Blue/Basic']};
  stroke-linecap: round;
  stroke-width: ${LOADER_STROKE_WIDTH};

  @keyframes loader-dash {
    0% {
      stroke-dasharray: ${MIN_ARC_LENGTH} ${CIRCUMFERENCE - MIN_ARC_LENGTH};
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: ${CIRCUMFERENCE * 0.75} ${CIRCUMFERENCE * 0.25};
      stroke-dashoffset: ${-CIRCUMFERENCE * 0.25};
    }
    100% {
      stroke-dasharray: ${MIN_ARC_LENGTH} ${CIRCUMFERENCE - MIN_ARC_LENGTH};
      stroke-dashoffset: ${-CIRCUMFERENCE};
    }
  }
`
